// Helpers de formato para Noticias. Centralizado aca para que la lista y el
// editor muestren fechas con el mismo criterio.

const DATE_FORMATTER = new Intl.DateTimeFormat('es-UY', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
})

export function formatFechaPublicacion(value: string | null | undefined): string {
  if (!value) return '—'
  // La API devuelve YYYY-MM-DD; evitamos problemas de timezone usando
  // new Date('YYYY-MM-DDT00:00:00') en la zona local.
  const iso = value.length === 10 ? `${value}T00:00:00` : value
  const date = new Date(iso)
  if (Number.isNaN(date.getTime())) return value
  return DATE_FORMATTER.format(date)
}

// Lista de schemes aceptados para URLs de CTA (ver /specs/admin-dashboard.md).
export const ALLOWED_CTA_SCHEMES = ['https://', 'wa.me/', 'tel:', 'mailto:'] as const

export function isValidCtaUrl(value: string): boolean {
  if (!value) return false
  return ALLOWED_CTA_SCHEMES.some((scheme) => value.startsWith(scheme))
}
